import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames/bind';

import SmartLink from 'marketing-website/components/modules/SmartLink';

import NavDropdownHeading from './NavDropdownHeading';
import NavItem from './NavItem';
import NavItemWithTitle from './NavItemWithTitle';

import styles from './style/desktop.module.css';
import sizeStyles from './style/colsizes.module.css';

function itemContent(item) {
  let content;
  if (item.title) {
    content = (
      <NavItemWithTitle title={item.title} description={item.description} />
    );
  } else {
    content = <NavItem description={item.description} />;
  }

  return content;
}

export default function NavDropdownColumn({ colHeading, size, listItems }) {
  const cx = classNames.bind({ ...sizeStyles });
  const colSize = cx(size, styles.column);

  return (
    <div className={colSize}>
      <NavDropdownHeading>{colHeading}</NavDropdownHeading>
      {listItems.map(item => (
        <div
          key={listItems.title}
          className="marginLeftRight-m marginBottom-xs fontSize-m"
        >
          <SmartLink type="licoriceToBlue" url={item.url} openInNewTab={false}>
            <div className={styles.hover}>{itemContent(item)}</div>
          </SmartLink>
        </div>
      ))}
    </div>
  );
}

NavDropdownColumn.propTypes = {
  colHeading: PropTypes.string,
  listItems: PropTypes.array.isRequired,
  size: PropTypes.string.isRequired,
};



// WEBPACK FOOTER //
// ./src/components/modules/Header/HeaderNav/NavDropdownColumn.js